import {Component, OnInit} from '@angular/core';
import {DashboardService} from '../dashboard.service';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {ToastrService} from 'ngx-toastr';
import {Location} from '@angular/common';

@Component({
    selector: 'app-create-article',
    templateUrl: './create-article.component.html',
    styleUrls: ['./create-article.component.css'],
    standalone: false
})

export class CreateArticleComponent implements OnInit {

  article = {
    title: '',
    type: 1,
    shortDescription: '',
    description: '',
    thumbnail: ''
  };
  admin: any = {};
  thumbnail: any;

  editorConfig: AngularEditorConfig = {
    editable: true,
    height: 'auto',
    minHeight: '10rem',
    minWidth: '70rem',
    enableToolbar: true,
    showToolbar: true,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['undo',
        'redo', 'strikeThrough',
        'subscript',
        'superscript', 'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
      ],
      ['fontSize', 'customClasses',
        'removeFormat',
        'textColor',
        'backgroundColor',
        'unlink',
        'insertVideo']
    ]
  };
  uploading = false;
  loading = false;

  constructor(
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    private _location: Location
  ) {
  }

  ngOnInit(): void {
    this.getCurrentUserData();
  }

  getCurrentUserData(): void {
    this.dashboardService.getCurrentUserData().subscribe((data) => {
      this.admin = data;
      // this.article.admin = this.admin.id;
    });
  }

  createArticle(): void {
    this.dashboardService.addArticle(this.article, this.thumbnail).subscribe((data) => {
      this.toastr.success('Article Published successfully !');
      this.goBack();
    }, err => this.toastr.error(err.error.message));
  }

  uploadImage(event): void {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.dashboardService.uploadImage({file: reader.result}).subscribe(res => {
        this.thumbnail = res.response.url;
        this.uploading = false;
      }, err => {
        this.uploading = false;
      });
    };
  }

  handleClickUpload(): void {
    const ele = document.getElementById('dp');
    if (!!ele) {
      ele.click();
    }
  }

  goBack(): void{
    this._location.back();
  }
}
